import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section aria-labelledby="hero-heading" className="bg-brand-paper px-5 pb-16 pt-8 lg:px-8 lg:pb-20 lg:pt-12" data-id="element-105" data-mp="16njcg4ablb52">
      <div className="mx-auto max-w-4xl text-center" data-id="element-106" data-mp="12m7rwd6azg3q">
        <p className="mx-auto w-fit rounded-full bg-brand-plum px-4 py-1.5 font-body text-[10px] font-bold uppercase tracking-[0.16em] text-white sm:text-[11px]" data-id="element-107" data-mp="12nsoe8c6h948">
          Makeup Instructors & Educators — This Is for You
        </p>

        <h1 id="hero-heading" className="mt-5 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-108" data-mp="1qbaapocobezt">
          Your Next Makeup Class Could Be <Accent data-id="element-109" data-mp="exeyand5lkca">Ready in Minutes.</Accent>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal/80 sm:text-[17px]" data-id="element-110" data-mp="9xaeand1e7hb">
          Stop spending hours planning lessons, exercises and student activities from scratch.
        </p>
      </div>

      <figure className="relative mx-auto mt-6 w-full max-w-[1060px]" data-id="element-111" data-mp="3de4obm9mec6s">
        <img src={MOCKUP_URL} alt="Makeup Instructor Ready — the six core volumes with real inside pages on a tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="block w-full object-contain" style={{
        filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
      }} data-id="element-112" data-mp="2zg6b4k71clsv" />
        <p className="mx-auto -mt-2 w-fit rounded-full border border-brand-plum/20 bg-white px-5 py-2 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-plum shadow-[0_10px_24px_-14px_rgba(59,27,87,0.5)] sm:-mt-4" data-id="element-113" data-mp="2gpouvf3e3ioe">
          6 Core Volumes + 5 Extra Bonuses
        </p>
      </figure>

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-114" data-mp="2bqbya2mpux8m">
        Open the system. Choose what you want to teach. And start preparing your class with professional
        lesson structures, technique guides, student exercises, assessments and instructor resources already
        organized for you.
      </p>

      <CtaBlock label="Yes! I Want My Classes Ready" note="One-Time Payment • Instant Digital Access • No Subscription" className="mt-8" data-id="element-115" data-mp="3ifk7yrvte4q" />
    </section>;
}